import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import { QuoteRequestMessage, QuoteRequestRecipient } from '../../../data/models';
import { EstimatesV2Service } from '../../services/estimateV2.service';
import { NotificationService } from '../../services/notification.service';
@Component({
    selector: 'app-rfq-response-messages',
    templateUrl: './rfq-response-messages.component.html',
    styleUrls: ['./rfq-response-messages.component.scss'],
    standalone: false,
})
export class RfqResponseMessagesComponent implements OnChanges, OnInit, OnDestroy {
    // @ts-ignore TS2564
    @Input() recipient: QuoteRequestRecipient;
    @Output() messageCountEvent: EventEmitter<number> = new EventEmitter<number>();
    // @ts-ignore TS2322
    current: QuoteRequestRecipient = null;
    messages: QuoteRequestMessage[] = [];
    newMessage = '';
    isNewMessageSubmitting = false;

    constructor(
        private estimatesV2Service: EstimatesV2Service,
        private notificationService: NotificationService
    ) {}

    private loadMessagesProxy: any;
    ngOnInit(): void {
        this.loadMessagesProxy = this.loadMessages.bind(this);
        this.notificationService.connection.on('NotifyMessageSent', this.loadMessagesProxy);
    }

    ngOnDestroy(): void {
        this.notificationService.connection.off('NotifyMessageSent', this.loadMessagesProxy);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const recipientChanged = changes['recipient'];
        if (recipientChanged && recipientChanged.currentValue !== recipientChanged.previousValue) {
            this.current = recipientChanged.currentValue;
            this.messages = [];
            this.messageCountEvent.emit(0);
            this.loadMessages();
        }
    }

    loadMessages(): void {
        if (this.current) {
            this.estimatesV2Service
                .getQuoteRequestRecipientMessages(this.current.iD_QuoteRequest, this.current.iD_QuoteRequestRecipient)
                .pipe(
                    first(),
                    catchError((e) => {
                        return EMPTY;
                    })
                )
                .subscribe((messages) => {
                    this.messages = messages.filter((message) => message.type === 'Info');
                    this.messageCountEvent.emit(this.messages.length);
                });
        }
    }

    sendMessage() {
        if (this.current) {
            this.isNewMessageSubmitting = true;
            this.estimatesV2Service
                .addQuoteRequestRecipientMessage(this.current.iD_QuoteRequest, this.current.iD_QuoteRequestRecipient, this.newMessage)
                .pipe(
                    first(),
                    catchError((e) => {
                        this.isNewMessageSubmitting = false;
                        return EMPTY;
                    })
                )
                .subscribe(() => {
                    //The message is loaded through the SignalR event, no need to add it here
                    // as it sometimes causes it to get added twice
                    this.newMessage = '';
                    this.isNewMessageSubmitting = false;
                });
        }
    }
}
